import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const assetsDueDisposalReportTodo = createAsyncThunk('assetsDueDisposalReport', async ({ params, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: process.env.REACT_APP_API_URL + `reports/assets-due-disposal`,
            params: {
                category_id: params?.category_id || undefined,
                status: 'Active',
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getSession("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const assetsDueDisposalReportSlice = createSlice({
    name: 'assetsDueDisposalReport',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(assetsDueDisposalReportTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = null
            }
        });
        builder.addCase(assetsDueDisposalReportTodo.rejected, () => { })
    }
})

export default assetsDueDisposalReportSlice.reducer;
